import { PrecificacaoComplemento } from "../enum/PrecificacaoComplemento";
import { ModeloPrecificacaoPizza } from "../enum/ModeloPrecificacaoPizza";

/**
 * Mapeia o modelo de precificação de uma pizza para a precificação de um grupo de complementos.
 * "Preço misto" não possui equivalente direto (alterna entre maior/dividido conforme a quantidade
 * de sabores), então é mapeado para "Maior preço".
 */
export const mapModeloPizzaParaPrecificacao = (modelo?: ModeloPrecificacaoPizza): PrecificacaoComplemento => {
    switch (modelo) {
        case ModeloPrecificacaoPizza["Preço dividido"]:
            return PrecificacaoComplemento["Preço dividido"];
        case ModeloPrecificacaoPizza["Maior preço"]:
        case ModeloPrecificacaoPizza["Preço misto"]:
            return PrecificacaoComplemento["Maior preço"];
        default:
            return PrecificacaoComplemento.Somar;
    }
};
